import apiClient from '@/services/axios'

export async function post(fileId) {
  const response = await apiClient.post(`/VenueDrive/SetDomainPermission?fileId=${fileId}`);
  if (response) {
    return response.data
  }

  throw new Error('Unable to set domain permissinon')
}